import { gql } from '@apollo/client';

export const CHECK_DISINTERMEDIATION = gql`
  query checkDisintermediation($textInput: String) {
    checkDisintermediation (textInput: $textInput) {
      containsContactDetails
      containsPrice
    }
  }
`;
